const BASE = '';

// ── SETUPS ────────────────────────────────────────────────────────────────────

export async function getSetups(userId) {
  const r = await fetch(`${BASE}/api/setups?user=${encodeURIComponent(userId)}`);
  return r.json();
}

export async function saveSetup(userId, setup, imageFiles = []) {
  const formData = new FormData();
  formData.append('user', userId);
  Object.entries(setup).forEach(([k, v]) => {
    if (v !== null && v !== undefined) {
      formData.append(k, typeof v === 'object' ? JSON.stringify(v) : String(v));
    }
  });
  imageFiles.forEach(f => formData.append('images', f));
  const r = await fetch(`${BASE}/api/setups`, { method: 'POST', body: formData });
  return r.json();
}

export async function updateChecklist(id, checklist) {
  await fetch(`${BASE}/api/setups/${id}/checklist`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ checklist }),
  });
}

export async function deleteSetup(id) {
  await fetch(`${BASE}/api/setups/${id}`, { method: 'DELETE' });
}

// ── CATALOGUE ─────────────────────────────────────────────────────────────────
// Handles all instrument types: my_gear, flip, servicing, watchlist

export async function getCatalogue(userId, type) {
  const typeParam = type ? `&type=${encodeURIComponent(type)}` : '';
  const r = await fetch(`${BASE}/api/catalogue?user=${encodeURIComponent(userId)}${typeParam}`);
  return r.json();
}

export async function createCatalogueItem(userId, data, imageFiles = []) {
  const formData = new FormData();
  formData.append('user', userId);
  Object.entries(data).forEach(([k, v]) => {
    if (v !== null && v !== undefined) {
      formData.append(k, typeof v === 'object' ? JSON.stringify(v) : String(v));
    }
  });
  imageFiles.forEach(f => formData.append('images', f));
  const r = await fetch(`${BASE}/api/catalogue`, { method: 'POST', body: formData });
  return r.json();
}

export async function updateCatalogueItem(id, data) {
  await fetch(`${BASE}/api/catalogue/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function deleteCatalogueItem(id) {
  await fetch(`${BASE}/api/catalogue/${id}`, { method: 'DELETE' });
}

export async function addSpend(catalogueId, userId, data) {
  const r = await fetch(`${BASE}/api/catalogue/${catalogueId}/spend`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...data, user: userId }),
  });
  return r.json();
}

export async function deleteSpend(catalogueId, spendId) {
  await fetch(`${BASE}/api/catalogue/${catalogueId}/spend/${spendId}`, { method: 'DELETE' });
}

export async function rotateCatalogueImage(id, imageUrl, degrees, imageIndex) {
  const r = await fetch(`${BASE}/api/catalogue/${id}/rotate-image`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ imageUrl, degrees, imageIndex }),
  });
  return r.json();
}

export async function uploadManual(id, file) {
  const fd = new FormData();
  fd.append('manual', file);
  const r = await fetch(`${BASE}/api/catalogue/${id}/manual`, { method: 'POST', body: fd });
  return r.json();
}

export async function deleteManual(id) {
  await fetch(`${BASE}/api/catalogue/${id}/manual`, { method: 'DELETE' });
}

// ── FLIP INSIGHTS (reads master_flips — no auth needed) ───────────────────────

export async function getFlipInsights(model, instrument) {
  const r = await fetch(`${BASE}/api/flips/insights?model=${encodeURIComponent(model||'')}&instrument=${encodeURIComponent(instrument||'')}`);
  return r.json();
}

// ── USER SETTINGS ─────────────────────────────────────────────────────────────

export async function getUserSettings(userId) {
  const r = await fetch(`${BASE}/api/user-settings/${encodeURIComponent(userId)}`);
  return r.json();
}

export async function saveUserSettings(userId, settings) {
  await fetch(`${BASE}/api/user-settings/${encodeURIComponent(userId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings),
  });
}

export async function dismissWelcome(userId) {
  await fetch(`${BASE}/api/user-settings/${encodeURIComponent(userId)}/dismiss-welcome`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function getCurrentTerms() {
  const r = await fetch(`${BASE}/api/terms/current`);
  return r.json();
}

export async function recordTermsAcceptance(userId, acceptedAt, source) {
  await fetch(`${BASE}/api/terms/accept`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, acceptedAt, source }),
  });
}

export async function checkTermsAcceptance(userId) {
  const r = await fetch(`${BASE}/api/terms/check?userId=${encodeURIComponent(userId)}`);
  return r.json();
}

export async function checkUsername(handle, excludeUserId) {
  const params = new URLSearchParams({ u: handle });
  if (excludeUserId) params.set('exclude', excludeUserId);
  const r = await fetch(`${BASE}/api/users/check-username?${params}`);
  return r.json();
}
